// When the section function is visible, disable the observer.
const initSectionVisiable = function(elemnts) {
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if (typeof elemnts.callback === 'function') {
          elemnts.callback();
          observer.unobserve(entry.target);
        }
      }
    });
  }, {rootMargin: `0px 0px ${elemnts.margin}px 0px`});
  observer.observe(elemnts.element);
};

if (!customElements.get('marquee-scroll')) {
customElements.define('marquee-scroll', class marqueeScroll extends HTMLElement {
  constructor() {
    super();
    this.scrolling = this.querySelector(".scrolling--item ");
    initSectionVisiable({
      element: this,
      callback: this.initScroll.bind(this),
      margin: 300,
    });
  }
  // Init Scolling
  initScroll() {
    const childCount = this.childElementCount === 1 ? true : false;
    if (childCount) {
      this.scrolling.classList.add("scrolling--animated");

      for (let i = 0; i < 10; i++) {
        this.clone = this.scrolling.cloneNode(true);
        this.clone.setAttribute("aria-hidden", true);
        this.appendChild(this.clone);
      }
      
      // Animation pause and run based on visible screen
      const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.classList.remove("scrolling--text--paused");
            } else {
              this.classList.add("scrolling--text--paused");
            }
          });
        },
        { rootMargin: "0px 0px 50px 0px" }
      );
      observer.observe(this);
    }
  }
});  
}

(function initStickyScrollingText() {
  const stickyRoot = document.querySelector(
    '[data-sticky-scrolling-text="true"]'
  );
  if (!stickyRoot || document.querySelector(".header__sticky")) return;

  const scrollingTextSection = stickyRoot.closest(".shopify-section");
  if (!scrollingTextSection) return;

  let placeholder = null;
  let isSticky = false;

  const setHeightVar = (height = 0) => {
    document.documentElement.style.setProperty(
      "--scrolling-text-sticky-height",
      `${height}px`
    );
  };

  const ensurePlaceholder = (height) => {
    if (!placeholder) {
      placeholder = document.querySelector(".scrolling-text-sticky-placeholder");
    }
    if (!placeholder) {
      placeholder = document.createElement("div");
      placeholder.className = "scrolling-text-sticky-placeholder";
      scrollingTextSection.parentNode.insertBefore(
        placeholder,
        scrollingTextSection.nextSibling
      );
    }
    placeholder.style.height = `${height}px`;
  };

  const removePlaceholder = () => {
    placeholder?.remove();
    placeholder = null;
    document.querySelector(".scrolling-text-sticky-placeholder")?.remove();
  };

  const getStickyThreshold = () => {
    if (placeholder) {
      return TopOffset(placeholder).top;
    }
    return TopOffset(scrollingTextSection).top;
  };

  const activateSticky = () => {
    if (isSticky) return;
    isSticky = true;

    const height = scrollingTextSection.offsetHeight;
    setHeightVar(height);
    ensurePlaceholder(height);
    scrollingTextSection.classList.add("scrolling-text--sticky-active");
  };

  const deactivateSticky = () => {
    if (!isSticky) return;
    isSticky = false;

    scrollingTextSection.classList.remove("scrolling-text--sticky-active");
    removePlaceholder();
    setHeightVar(0);
  };

  setHeightVar(0);

  window.addEventListener("resize", function () {
    if (!isSticky) return;
    const height = scrollingTextSection.offsetHeight;
    ensurePlaceholder(height);
    setHeightVar(height);
  });

  window.addEventListener("scroll", function () {
    if (window.scrollY > getStickyThreshold()) {
      activateSticky();
    } else {
      deactivateSticky();
    }
  });
})();
